import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';

const textStyle = {
  maxWidth: '350px',
};

const OverlayTitle: FC = ({ children }) => (
  <Typography align="center" component="h2" style={textStyle} variant="h1">
    {children}
  </Typography>
);

const OverlayText: FC = ({ children }) => (
  <Typography align="center" style={textStyle} variant="body1">
    {children}
  </Typography>
);

const OverlayIcon: FC = ({ children }) => (
  <SvgIcon
    color="primary"
    sx={(theme) => ({
      fontSize: `calc(${theme.typography.body1.fontSize} * 4)`,
    })}
  >
    {children}
  </SvgIcon>
);

export { OverlayTitle, OverlayText, OverlayIcon };

export interface OverlayProps {
  [x: string]: any;
}

const Overlay: FC<OverlayProps> = ({ children, icon, text, title }) => {
  return (
    <Stack
      alignItems="center"
      gap={1}
      justifyContent="center"
      style={{ background: 'transparent', height: '100%', width: '100%' }}
    >
      {children || (
        <>
          <OverlayIcon>{icon}</OverlayIcon>
          <OverlayTitle>{title}</OverlayTitle>
          <OverlayText>{text}</OverlayText>
        </>
      )}
    </Stack>
  );
};

export default Overlay;
